import {isomorphicGlobal} from "@gongt/ts-stl-library/check-environment";
import {GlobalVariable} from "@gongt/ts-stl-library/pattern/global-page-data";

export let globalVar: GlobalVariable;
const realGlobalVar = new GlobalVariable(isomorphicGlobal);

// this file used by many different position, so environment is different.
declare const CLIENT_JS_CONFIG;
declare const CLIENT_DATA_PAGE;
declare const process;

if (typeof process !== 'undefined') {
	// exists only in server code.
	// the global data already init in
	//     package/index
	//     server/config-start
	globalVar = realGlobalVar;
} else if (typeof CLIENT_JS_CONFIG !== 'undefined') {
	// exists only in `client.js` file
	//   no matter it run at which page
	console.info('running client.js itself.');
	globalVar = new GlobalVariable({});
	globalVar.set(realGlobalVar.getObject());
	globalVar.set(CLIENT_JS_CONFIG);
} else if (typeof CLIENT_DATA_PAGE !== 'undefined') {
	// only exists and must exists
	//   on every http://accounts/* page
	console.info('running on user-center page.');
	globalVar = realGlobalVar;
	globalVar.set(CLIENT_DATA_PAGE);
	globalVar.set('baseDomainName', location.host);
	globalVar.set('baseProtocol', location.protocol);
} else {
	console.warn('do not know where im running.');
	if (!globalVar.get('baseDomainName') || !globalVar.get('baseProtocol')) {
		throw new Error('config error: no baseDomainName & baseProtocol.')
	}
}

/* ^^^ global variable init complete ^^^*/

export const baseDomainName = globalVar.get('baseDomainName');
export const baseProtocol = globalVar.get('baseProtocol');

export const IS_IN_CHINA = globalVar.get('isChina');

export const PAGE_DEBUG_ID: string = (() => {
	let debugId = globalVar.get('debugId');
	if (debugId) {
		return debugId;
	}
	if (isomorphicGlobal['debugId']) {
		return isomorphicGlobal['debugId'];
	}
	if (typeof process === 'object' && process.env.PROJECT_NAME) {
		return process.env.PROJECT_NAME;
	}
	return '???';
})();

if (!baseDomainName && baseProtocol) {
	throw new Error('has protocol, but no domain.');
}

export const BASE_DOMAIN_NAME = baseDomainName;
export const BASE_PROTOCOL = baseProtocol;
export const CONFIG_BASE_DOMAIN = BASE_PROTOCOL + '//' + BASE_DOMAIN_NAME;

export const EVENT_TYPE_LOCAL_USER_CHANGE = 'LOCAL_USER_CHANGE';
export const EVENT_KEY = 'EVENT_KEY';
export const EVENT_TYPE_FORGET_REDIRECT = 'FORGET_REDIRECT';
export const EVENT_TYPE_DISTRIBUTE = 'DISTRIBUTE';
export const EVENT_TYPE_LOGIN = 'LOGIN_RESPONSE';
export const EVENT_TYPE_CHILD_CLOSE = 'SUB_WINDOW_CLOSE';
export const EVENT_TYPE_LOGIN_FAIL_CLOSE = 'LOGIN_FAIL_CLOSE';
export const EVENT_TYPE_LOGIN_REQUEST = 'LOGIN_REQUEST';
export const EVENT_TYPE_IFRAME_READY = 'IFRAME_READY';
export const EVENT_TYPE_IFRAME_RPC = 'IFRAME_RPC';
export const EVENT_TYPE_IFRAME_RPC_REPLY = 'IFRAME_RPC_REPLY';
export const EVENT_TYPE_IFRAME_RESIZE = 'IFRAME_RESIZE';
export const EVENT_TYPE_MESSAGE_FUNCTION_TEST = 'MESSAGE_FUNCTION_TEST';

export const PACKAGE_LOGIN_COOKIE_NAME = 'user-login-token.plain';
export const PACKAGE_LOGIN_HEADER_NAME = 'x-login-token';
export const REMEMBER_LOGIN_TOKEN_NAME = 'user-token-remember.signed';
export const LIBRARY_LOGIN_COOKIE_NAME = 'uclogintoken.signed';
export const LIBRARY_LOGIN_COOKIE_CACHE_NAME = 'client-cache-string';
export const REFRESH_TOKEN_GET_PARAM_NAME = 'token';

export const LOGIN_BASE_DOMAIN: string = CONFIG_BASE_DOMAIN + '/';
export const CLIENT_LIBRARY_ABSOLUTE_URL: string = CONFIG_BASE_DOMAIN + '/public';

export const PROVIDER_BASE_URL: string = '/3rd';
export const API_BASE_URL: string = '/api';
export const CLIENT_LIBRARY_BASE_URL: string = '/client-library';
export const CLIENT_LIBRARY_FILE_NAME = 'client.js';
export const CLIENT_LIBRARY_URL = CLIENT_LIBRARY_BASE_URL + '/' + CLIENT_LIBRARY_FILE_NAME;
export const PUBLIC_BASE_URL: string = '/public';
